export default (params) => ({
  trigger: {
    name: 'recommended_accessories.select_color_alternative',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'color_collection',
        method: 'image',
      },
    },
  },
});
